'use strict';

import React, { memo } from 'react';
import { BaseEdge } from '@xyflow/react';
import { getPipelineStatusOrthogonalPath } from './pipelineStatusGraphEdge';

/**
 * @param {{
 *   id?: string,
 *   sourceX: number,
 *   sourceY: number,
 *   targetX: number,
 *   targetY: number,
 *   style?: import('react').CSSProperties,
 *   markerEnd?: string,
 *   markerStart?: string,
 * }} props
 */
function PipelineStatusEdgeInner({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
	style,
	markerEnd,
	markerStart,
}) {
	const [edgePath] = getPipelineStatusOrthogonalPath({ sourceX, sourceY, targetX, targetY });

	return (
		<BaseEdge
			id={id}
			path={edgePath}
			style={style}
			markerEnd={markerEnd}
			markerStart={markerStart}
		/>
	);
}

export const PipelineStatusEdge = memo(PipelineStatusEdgeInner);
